import { Observable } from 'rxjs';

import { UserNote } from 'user/note/user-note';

export abstract class UserNoteRepositoryPort {
	public abstract persistUserNotes(userNotes: UserNote[]): Promise<void>;

	public abstract deleteNoteById(noteId: string): Promise<void>;

	public abstract observeNotes(notesId: string[]): Observable<UserNote[]>;
}
